import { LOCALE, LOCALEMOBILE } from '../enum/locale';

export const FALLBACK_LOCAL = LOCALE.ID;

export const supportedLocales: LOCALE[] = [LOCALE.ID, LOCALE.EN];
export const supportedLocalesMobile: LOCALEMOBILE[] = [
  LOCALEMOBILE.Indonesian,
  LOCALEMOBILE.English,
];

export const localOfLanguage: Record<string, LOCALE> = {
  id: LOCALE.ID,
  en: LOCALE.EN,
};
